import api from '../../api/api'
import url from '../../api/env'
import Utils from '../../utils/Utils'

const getAllStores = async () =>
    api
        .get(`${url.stage.stores_options}?paginate=0&sort_type=desc`, {})
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getAllPaymentMethods = async () =>
    api
        .get(`${url.stage.paymentMethod_options}?paginate=0`, {})
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getAllProviders = async () =>
    api
        .get(`${url.stage.Providers_options}?paginate=0`, {})
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getNextPage = async urlNextPage =>
    api
        .get(`${urlNextPage}`, {})
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getTransfers = async (id, filter = '') => {
    return api
        .get(`${url.stage.transfers}?sort_type=desc&store_id=${id}&per_page=5&date=${filter}%`, {})
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))
}

const storeTransfer = async data =>
    api
        .post(`${url.stage.transfers}`, data)
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getOrders = async (id) => {
    return api
        .get(`${url.stage.orders}?sort_type=desc&store_id=${id}&per_page=5`, {})
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))
}

const getOrder = async id =>
    api
        .get(`${url.stage.orders}/${id}`, {})
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const updateOrder = async (id, data) =>
    api
        .put(`${url.stage.orders}/${id}`, data)
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const updateProducts = async (id, data) =>
    api
        .put(`${url.stage.orders}/details/${id}`, data)
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getCounts = async (id, filter = '') =>
    api
        .get(`${url.stage.counts}?sort_type=desc&store_id=${id}&per_page=5&count_date=${filter}%`, {})
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getAllPurchases = async (id, filter = '', excludeChars, sort_type = 'desc') =>
    api
        .get(excludeChars ? `${url.stage.purchases}?sort_type=${sort_type}&store_id=${id}&per_page=5&invoice=%${encodeURIComponent(filter)}%` : encodeURI(`${url.stage.purchases}?sort_type=${sort_type}&store_id=${id}&per_page=5&invoice=%${filter}%`), {})
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getPurchase = async id =>
    api
        .get(`${url.stage.purchases}/${id}`, {})
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getInventory = async (id, paginate = true, filter = '', low_stock = false, excludeChars, sort_type = 'desc', product_id = null) => {
    const path = excludeChars ? `${url.stage.inventory}?sort_type=${sort_type}&store_id=${id}&${paginate ? 'per_page=5' : 'paginate=0'}&product_description=%${encodeURIComponent(filter)}%${low_stock ? '&low_stock=1' : ''}` : encodeURI(`${url.stage.inventory}?sort_type=${sort_type}&store_id=${id}&${paginate ? 'per_page=5' : 'paginate=0'}&product_description=%${filter}%${low_stock ? '&low_stock=1' : ''}`)

    return api
        .get(product_id ? `${url.stage.inventory}?sort_type=desc&store_id=${id}&paginate=0&product_id=${product_id}` : path, {})
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))
}
const getStockOptions = async (id, paginate = true, filter = '', low_stock = false, excludeChars, sort_type = 'desc') =>
    api
        .get(excludeChars ? `${url.stage.stockOptions}?sort_type=${sort_type}&store_id=${id}&${paginate ? 'per_page=5' : 'paginate=0'}&product_description=%${encodeURIComponent(filter)}%${low_stock ? '&low_stock=1' : ''}` : encodeURI(`${url.stage.stockOptions}?sort_type=${sort_type}&store_id=${id}&${paginate ? 'per_page=5' : 'paginate=0'}&product_description=%${filter}%${low_stock ? '&low_stock=1' : ''}`), {})
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getSkusOptions = async () =>
    api
        .get(`${url.stage.SkusOptions}?paginate=0`, {})
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getAdjustments = async (id, filter = '') =>
    api
        .get(`${url.stage.adjustments}?sort_type=desc&store_id=${id}&per_page=5&date=${filter}%`, {})
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const savePurchase = async data =>
    api
        .post(url.stage.purchases, data)
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const editPurchase = async (id, data) =>
    api
        .put(`${url.stage.purchases}/${id}`, data)
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearFoAuthError() : console.log(err)))

const saveAdjustment = async data =>
    api
        .post(url.stage.adjustments, data)
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const saveCounts = async data =>
    api
        .post(url.stage.counts, data)
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const adjustCounts = async data =>
    api
        .post(url.stage.countsAdjustments, data)
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const removeCount = async stockCountId =>
    api
        .remove(`${url.stage.counts}/${stockCountId}`)
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const searchPresentations = async (value, excludeChars, sort_type = 'desc') =>
    api
        .get(excludeChars ? `${url.stage.Presentations_options}?sort_type=${sort_type}&presentation_description=%${encodeURIComponent(value)}%&sku_code=%${encodeURIComponent(value)}%&paginate=0` : encodeURI(`${url.stage.Presentations_options}?sort_type=${sort_type}&presentation_description=%${value}%&sku_code=%${value}%&paginate=0`), {})
        .then(res => res)
        .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

export default {
    adjustCounts,
    getAdjustments,
    getAllPaymentMethods,
    getAllProviders,
    getAllStores,
    getCounts,
    getAllPurchases,
    getPurchase,
    getInventory,
    getNextPage,
    getTransfers,
    getOrders,
    getOrder,
    updateOrder,
    updateProducts,
    storeTransfer,
    savePurchase,
    editPurchase,
    removeCount,
    saveAdjustment,
    saveCounts,
    searchPresentations,
    getStockOptions,
    getSkusOptions
}
